<template>
  <div class="circle circleNext">
    <img :src="require(`@/assets/icons/next.svg`)">
  </div>
</template>

<script>
export default {
  name: "IconNext"
};
</script>

<style>
.circleNext{
  margin: 2rem;
}
</style>
